import {
  hygieneCheck,
  pointsAccured,
  targetAchievement,
} from '@constants/endpoints';
import { DefaultInterface } from '@utils/types';
import { axiosInstance } from '.';

export const getTargetVsAchievement: DefaultInterface = async () => {
  const response = await axiosInstance.get(targetAchievement);
  return response.data ?? false;
};

export const getPoints: DefaultInterface = async () => {
  const response = await axiosInstance.get(pointsAccured);
  return response.data ?? false;
};

export const getHygieneCheck: DefaultInterface = async () => {
  const response = await axiosInstance.get(hygieneCheck);
  return response.data ?? false;
};
